import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { List } from 'immutable';
import { forkJoin, of } from 'rxjs';
import { BaseDataService, BaseUpdateComponent, NotificationService, CryptoService, QueryParameter, ModalService } from 'yt-ng-framework';
import { DonosEkranskaKarticaKomitenata } from './donos-ekranska-kartica-komitenata';
import { EkranskaKarticaKomitenata } from './ekranska-kartica-komitenata';
import { TekuceEkranskiPregledKomitenata } from './tekuce-ekranski-pregled-komitenata';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-ekranska-kartica-komitenata-update',
  templateUrl: './ekranska-kartica-komitenata-update.component.html'
})
export class EkranskaKarticaKomitenataUpdateComponent extends BaseUpdateComponent<EkranskaKarticaKomitenata> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService
  ) {
    super(activatedRoute
      , baseDataService
      , toastrService
      , translateService
      , modalService);
  }

  @Output()  newEventEmitter = new EventEmitter();

  Config = {}
  ConfigTekuce = {}
  TableColumns = [{}];
  DonosTableColumns = [{}];
  TableColumnsSums = [{}];
  TableColumnsUkupno = [{}]
  items;
  DonosItems;
  UkupnoItems=List([{
    UkupnoDuguje: 0,
    UkupnoPotrazuje: 0,
    Ukupno: 0
  }]);
  Ukupno = List([]);
  date


  filter = {
    dateFrom : {},
    dateTo : {},
    orgJedIDs: {}
  }

  ngOnInit() {
    this.LoadData(this.Item.ID);

    this.Config = {
      EditIcon: {
        Visible: false
      },
      DeleteIcon: {
        Visible: false
      },
      DefaultSortKey: 'DatumDokumenta',
      //DefaultSortReverse: true,
      ShowIndex: false,
      ShowDefaultListButtons: false,
      //Height: '100c',
      IsModal: true,
      ShowCheckBoxes: false,
      //ShowHeader: false,
      ShowSearch: false,
      ShowFooter: false,
      PrintIcon: {
        Visible: false
      }
      , BreadCrumble: 'EKRANSKAKARTICAKOMITENATA.SINGULAR'
    }

    this.ConfigTekuce = {
      EditIcon: {
        Visible: false
      },
      DeleteIcon: {
        Visible: false
      },
      DefaultSortKey: 'DatumDokumenta',
      DefaultSortReverse: true,
      ShowIndex: false,
      ShowDefaultListButtons: false,
      //Height: '400px',
      IsModal: true,
      ShowCheckBoxes: false,
      //ShowHeader: false,
      //ShowFooter: false,
      ShowSearch: false,
      PrintIcon: {
        Visible: false
      }
      , BreadCrumble: 'EKRANSKAKARTICAKOMITENATA.SINGULAR'
    }

    this.TableColumns = [
      { Name: 'BrojDokumenta', Label: 'EKRANSKAKARTICAKOMITENATA.BROJDOKUMENTA.SINGULAR', Visible: true, CanHide: false, Width: '15%' },
      { Name: 'DatumDokumenta', Label: 'EKRANSKAKARTICAKOMITENATA.DATUMDOKUMENTA.SINGULAR', Visible: true, CanHide: false, Width: '12%', Type: 'ngbDate', Format: 'dd.MM.yyyy', Aligment: 'right'},
      { Name: 'OrgJed', Label: 'EKRANSKAKARTICAKOMITENATA.ORGJED.SINGULAR', Visible: true, CanHide: false, Width: '23%' },
      { Name: 'TekuceDuguje', Label: 'EKRANSKAKARTICAKOMITENATA.TEKUCEDUGUJE.SINGULAR', Visible: true, CanHide: false, Width: '15%', Type: 'number', Aligment: 'right', Format: '1.2-2'  },
      { Name: 'TekucePotrazuje', Label: 'EKRANSKAKARTICAKOMITENATA.TEKUCEPOTRAZUJE.SINGULAR', Visible: true, CanHide: false, Width: '15%', Type: 'number', Aligment: 'right', Format: '1.2-2'  },
      { Name: 'TekuceUkupno', Label: 'EKRANSKAKARTICAKOMITENATA.TEKUCEUKUPNO.SINGULAR', Visible: false, CanHide: false, Width: '15%', Type: 'number', Aligment: 'right', Format: '1.2-2'  }
      //{ name: 'Datum', label: 'FAKDOKUMENT.DATDOK.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', Visible: true, VanHide: false, Width: '17%' }
      
    ]

    this.DonosTableColumns = [
      { Name: 'DonosDuguje', Label: 'EKRANSKAKARTICAKOMITENATA.DONOSDUGUJE.SINGULAR', Visible: true, CanHide: false, Width: '35%', Type: 'number', Aligment: 'right', Format: '1.2-2'  },
      { Name: 'DonosPotrazuje', Label: 'EKRANSKAKARTICAKOMITENATA.DONOSPOTRAZUJE.SINGULAR', Visible: true, CanHide: false, Width: '35%', Type: 'number', Aligment: 'right',Format: '1.2-2'  },
      { Name: 'DonosUkupno', Label: 'EKRANSKAKARTICAKOMITENATA.DONOSUKUPNO.SINGULAR', Visible: true, CanHide: false, Width: '35%', Type: 'number', Aligment: 'right',Format: '1.2-2'  }
    ]

    this.TableColumnsSums = [
      {
        Columns: 'TekuceDuguje, TekucePotrazuje, TekuceUkupno'
      }
    ]

    this.TableColumnsUkupno = [
      { Name: 'UkupnoDuguje', Label: 'EKRANSKAKARTICAKOMITENATA.UKUPNODUGUJE.SINGULAR', Visible: true, CanHide: false, Width: '35%', Type: 'number', Aligment: 'right', Format: '1.2-2'},
      { Name: 'UkupnoPotrazuje', Label: 'EKRANSKAKARTICAKOMITENATA.UKUPNOPOTRAZUJE.SINGULAR', Visible: true, CanHide: false, Width: '35%', Type: 'number', Aligment: 'right', Format: '1.2-2' },
      { Name: 'Ukupno', Label: 'EKRANSKAKARTICAKOMITENATA.UKUPNO.SINGULAR', Visible: true, CanHide: false, Width: '35%', Type: 'number', Aligment: 'right', Format: '1.2-2' },
    ]
  }

  LoadData(Id){

    
forkJoin([
  this.baseDataService.Post("FakReports","EkranskiPregledStanjaGetByKomitent", this.postaviFilter(), TekuceEkranskiPregledKomitenata, new QueryParameter('KomitentId', Id)),
  this.baseDataService.Post("FakReports","EkranskiPregledStanjaGetDonosByKomitent", this.postaviFilter(), DonosEkranskaKarticaKomitenata, new QueryParameter('KomitentId', Id))
]).subscribe(data => {
  this.items = List(data[0] || []);
  this.DonosItems = List(data[1] || []);

  for (let i = 0; i < this.items.size; i++) {
    const r = this.items.get(i) || {};
    this.UkupnoItems.get(0).UkupnoDuguje    += r.TekuceDuguje    || 0;
    this.UkupnoItems.get(0).UkupnoPotrazuje += r.TekucePotrazuje || 0;
    this.UkupnoItems.get(0).Ukupno          += r.TekuceUkupno    || 0;
  }

  if (this.DonosItems.size > 0) {
    const d0 = this.DonosItems.get(0) || {};
    this.UkupnoItems.get(0).UkupnoDuguje    += d0.DonosDuguje    || 0;
    this.UkupnoItems.get(0).UkupnoPotrazuje += d0.DonosPotrazuje || 0;
    this.UkupnoItems.get(0).Ukupno          += d0.DonosUkupno    || 0;
  }

  this.Ukupno = this.UkupnoItems;
});

    

    // this.baseDataService.Post("FakReports", "EkranskiPregledStanjaGetByKomitent", this.postaviFilter(), TekuceEkranskiPregledKomitenata, new QueryParameter('KomitentId', Id))
    // .subscribe(values =>{
    //   this.items = values;
    // });

    // this.baseDataService.Post("FakReports", "EkranskiPregledStanjaGetDonosByKomitent", this.postaviFilter(), DonosEkranskaKarticaKomitenata, new QueryParameter('KomitentId', Id))
    // .subscribe(values =>{
    //   this.DonosItems = values;
    // });

    // this.UkupnoItems = this.DonosItems.DonosUkupno
  }

  Load(ID: number){
    return of(1);
  }

  postaviFilter(){
     let dateNow = new Date();
     let datum = new NgbDate(dateNow.getFullYear(), dateNow.getMonth(), 1);
    // this.filter.dateTo = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate());
    // return this.filter;
    this.filter.dateFrom = CryptoService.Decrypt(sessionStorage.getItem('KarticaKomitentaDatumOd'));
    this.filter.dateTo = CryptoService.Decrypt(sessionStorage.getItem('KarticaKomitentaDatumDo'));
    this.filter.orgJedIDs = CryptoService.Decrypt(sessionStorage.getItem('OrgJedIDs'));
    //this.newEventEmitter.emit(this.filter);
    return this.filter;
  }


  Print() {
    let print = true;

    this.translateService
      .get(this.modalService.ConvertPluralToSingular(this.modelData.BreadcrumbLabel))
      .subscribe((translate) => {

        this.modalService
          .ShowPrintDialog(
            translate,
            this.modelData.MainList.EnablePrintAccountSelection,
            false
          )
          .result.then((value) => {
            const reportPars: { Name: string; Value: any }[] = [];

            reportPars.push(
              { Name: 'IDs', Value: this.Item.ID },
              { Name: 'PrintMethod', Value: this.modelData.MainList.PrintName }
            );

            reportPars.push(
                { Name: 'dateFrom', Value: this.filter.dateFrom },
                { Name: 'dateTo', Value: this.filter.dateTo },
                { Name: 'orgJedIDs', Value: this.filter.orgJedIDs }
            );

            this.baseDataService
              .GetFile(
                this.modelData.MainList.PrintController,
                "Printaj",
                {
                  ReportPars: reportPars,
                  WipsPars: {
                    parReportTitle: value.Title,
                    parReportSubtitle: value.SubTitle,
                    parPageNoYes: value.ShowPageCount,
                    parPageNoPosition: value.PageNoPosition,
                    parTimeZoneInfo: 'Central Europe Standard Time',
                    parHeaderType: value.ReportHeaderTypes,
                    parPageFooterType: value.ReportPageTypes,
                    parCompanyAccounts: value.FirmaZrcs,
                    parIzvestajId: value.TipDokumenta,
                    parOdloziIUEregistrator: value.Eregistrator
                  }
                }
              )
              .subscribe((file) => {
                const fileUrl = URL.createObjectURL(file);
                window.open(fileUrl);
              });
          });
      });
  }


}
